export default __webpack_public_path__ + "static/Supply-UltraLight-963cc34ae7c5e29ed67c538302ee1c80.woff";